module.exports = __webpack_public_path__ + "3bdae2c881802253008aadb0a360820a.svg";